import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';

@Injectable({ providedIn: 'root' })
export class AuthUserLookupTool implements IManagementTool {
  private _router = inject(Router);

  readonly name = 'auth-user-lookup';
  readonly label = 'Auth User Lookup';
  readonly icon = 'person_search';
  readonly description = 'Navigate to the auth user management page';

  async run(_context: IToolRunContext): Promise<void> {
    await this._router.navigate(['/management/tools/auth-user-lookup']);
  }
}
